export default "<div>\r\n    <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\r\n</div>\r\n<ngx-ui-loader fgsSize=\"100\"></ngx-ui-loader>"